import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, makeStyles } from '@material-ui/core';
import StandardLayout from 'components/Layouts/Standard';
import { X_PATH } from 'constants/xPath';
import InlineButton from '#web-components/components/InlineButton';
import Typography from '#web-components/components/Typography';
import { ReactComponent as LinkIcon } from '#web-components/assets/icons/link.svg';
import { FileIcon } from '#web-components/components/Icons';
import styles from './ReportListPage.styles';

const useStyles = makeStyles(styles, { name: 'ReportListPage' });
export default function ReportListPage() {
  const classes = useStyles();
  const { t } = useTranslation('pages', { keyPrefix: 'reportsList' });

  const handleClick = useCallback(() => {
    const a = document.createElement('a');
    a.target = '_blank';
    a.href = ENVIRONMENT_VARIABLES.redashUrl;
    a.click();
  }, []);

  return (
    <StandardLayout title={t('title')}>
      <div className={classes.root}>
        <FileIcon variant="h1" className={classes.file} />
        <Typography variant="textRegular">
          {t('description')}
        </Typography>
        <Box className={classes.box}>
          <InlineButton
            data-xpath={X_PATH.reportsLinkButton}
            size="large"
            leftIcon={<LinkIcon />}
            onLinkClick={handleClick}
          >
            {t('linkText')}
          </InlineButton>
        </Box>
      </div>
    </StandardLayout>
  );
}
